'use strict';

import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {h, Fragment} from 'preact';
import Goods from './Goods';
import {Link, useParams, useLocation} from 'react-router-dom';
import supplant from '../../utility/supplant';
import axios from '../../utility/axios';
import Breadcrumbs from '../Breadcrumbs';
import {langPath} from '../../utility/url';
import {block, unblock} from '../../../src/block-ui';
import useQuery from "../../utility/useQuery";

export default function TechModels(props) {
    const [state, setState] = useState(props.tech || {});
    const params = useParams();
    const query = useQuery();
    const pageName = ~~query.get('start');
    const {pathname} = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        if (props.tech && params.tech === props.tech.url) {
            return;
        }

        const url = supplant('/api/models/brand-{brand}/tech-{tech}/', {...params});

        block();

        axios.get(url).then(response => {
            setState(response.data);
            unblock();
        });
    }, [props.tech, params]);

    const updateGoods = useCallback(
        items => {
            const newState = {...state};
            newState.goods = items;

            setState(newState);
        },
        [state]
    );

    return (
        <div>
            {state.breadcrumbs && <Breadcrumbs items={state.breadcrumbs.stack} />}

            <h1 className='brand-title' dangerouslySetInnerHTML={{__html: state.h1}}></h1>

            {state.details && state.isFirstPage && (
                <div className='catalog_list'>
                    <ul className='category-list'>
                        {state.details.map((item, index) => (
                            <li className='category-list_item' key={index}>
                                <div
                                    className='category-list_img'
                                    style={{background: `url("${item.icon}") no-repeat 50%`}}></div>
                                <a href={item.url} className='category-list_link' title={item.title}>
                                    {item.title}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {state.topModels && (
                <div
                    style={{
                        columns: '245px auto',
                        fontSize: '8pt',
                        margin: '10px',
                        marginTop: '1rem',
                        marginBottom: '2rem',
                        padding: '10px',
                        border: '1px solid #c0cede',
                        borderBottom: '3px solid #e0e0e0',
                        borderRadius: '5px',
                    }}>
                    {state.topModels.map((model, index) => (
                        <div key={index}>
                            <Link
                                to={langPath(model.url)}
                                title={model.title}
                                dangerouslySetInnerHTML={{__html: model.content}}></Link>
                        </div>
                    ))}
                </div>
            )}

            <div id='products' className='wrap_items grid'>
                {!state.isCityMode && state.h1 && (
                    <Goods
                        items={state.goods}
                        url={'/api/models/brand-{brand}/tech-{tech}/goods/?start={page}'}
                        pagination={state.pagination}
                        onUpdate={updateGoods}
                    />
                )}
            </div>

            {
                !global.config.isOffice
                && pageName < 2
                && <div dangerouslySetInnerHTML={{__html: state.seoBlock}}></div>
            }

            {state.isCityMode && <div dangerouslySetInnerHTML={{__html: state.text}}></div>}

            <div className='clear'></div>

        </div>
    );
}
